import React from 'react';
import { useFieldArray } from 'react-hook-form';
import { Text, Stack, HStack } from '@chakra-ui/react';
import TemplateSelectEdit from './TemplateSelectEdit';
import QuestionCardCertification from '../../../../components/Card/Question-card-certification';
import IdentidadeDoPilar from '../../../../components/Questionnaires/IdentidadeDoPilar';

const PillarConfigEdit = ({
 index,
 field,
 register,
 errors,
 control,
 trigger,
 setValue,
 templates,
 templatesIsLoading,
}) => {
 // EG-42: o carregamento da imagem virou responsabilidade do IdentidadeDoPilar,
 // que serve criação e edição com a mesma apresentação.
 const pillarImage = field?.pillarImage || null;

 const {
  fields: questions,
  append: appendQuestions,
  remove: removeQuestions,
 } = useFieldArray({
  control,
  name: `form.${index}.questions`,
 });

 const addQuestion = (question) => {
  if (!questions.some((q) => q.id_question_template === question.id_question_template)) {
   appendQuestions(question);
  }
 };

 // Function to remove a question from questions array
 const removeQuestion = (questionId) => {
  const questionIndex = questions.findIndex((q) => q.id_question_template === questionId);
  if (questionIndex !== -1) {
   removeQuestions(questionIndex);
  }
 };

 return (
  // EG-42: mesma caixa do periódico — sem padding lateral no container, para a
  // barra azul de "Perguntas" ir de ponta a ponta. O p='6' aqui era o que fazia
  // a barra ficar recuada e a tela parecer diferente da do periódico.
  <Stack spacing='0'>
   {/* EG-42: imagem e texto do pilar passaram a SOMENTE LEITURA.
       São conteúdo do catálogo GLOBAL — pós-EG-40 o mesmo "Ambiental" serve
       vários clientes, e gravá-los daqui mudava o conceito para todos. Mesma
       família dos três botões que a AD-5 aposentou. Continuam visíveis porque a
       informação é rica para quem monta o questionário; editar é no catálogo. */}
   <IdentidadeDoPilar imgPillar={pillarImage} textPillar={field?.pillarText} />

   <HStack h='51px' bg='#E6F1F8' p='16px'>
    <Text color='#0073BB' fontWeight={600}>
     Perguntas
    </Text>
   </HStack>

   <Stack p='6' spacing='6'>
    <TemplateSelectEdit
     templates={templates}
     templatesIsLoading={templatesIsLoading}
     addQuestion={addQuestion}
     existingQuestions={questions}
    />
    <Stack spacing='4'>
     {questions?.map((question, i) => (
      <QuestionCardCertification
       key={question?.id_question_template}
       index={i}
       remove={() => removeQuestion(question.id_question_template)}
       question={question}
      />
     ))}
    </Stack>
   </Stack>
  </Stack>
 );
};

export default React.memo(PillarConfigEdit);
